import React, { useState } from 'react';
import { Layout, Menu, Button, Typography, Avatar, Drawer } from 'antd';
import {
  UnorderedListOutlined, LogoutOutlined, UserOutlined,
  TeamOutlined, HomeOutlined, MenuOutlined,
} from '@ant-design/icons';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const { Header, Content } = Layout;

const SIDEBAR_W = 200;

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = user?.role === 'admin';
  const [drawerOpen, setDrawerOpen] = useState(false);

  const go = (path: string) => { navigate(path); setDrawerOpen(false); };

  const menuItems = [
    { key: '/my-sheep',  icon: <HomeOutlined />,           label: 'Мои бараны',     onClick: () => go('/my-sheep') },
    { key: '/',          icon: <UnorderedListOutlined />,   label: 'Все бараны',     onClick: () => go('/') },
    ...(isAdmin ? [
      { key: '/users',   icon: <TeamOutlined />,            label: 'Пользователи',   onClick: () => go('/users') },
    ] : []),
  ];

  const sidebarContent = (
    <div style={{ background: '#1a1a2e', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{
        height: 56, display: 'flex', alignItems: 'center',
        justifyContent: 'center', color: '#fff', fontSize: 18, fontWeight: 700,
        borderBottom: '1px solid #2d2d4e',
      }}>
        🐑 Арашан
      </div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        style={{ background: '#1a1a2e', borderRight: 0, flex: 1 }}
        items={menuItems}
      />
    </div>
  );

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>

      {/* ── Десктопный сайдбар (только ≥768px) ── */}
      <div className="desktop-sidebar" style={{
        width: SIDEBAR_W, flexShrink: 0,
        position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 200,
      }}>
        {sidebarContent}
      </div>

      {/* ── Мобильный Drawer ── */}
      <Drawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        placement="left"
        width={SIDEBAR_W}
        styles={{ body: { padding: 0 }, header: { display: 'none' } }}
      >
        {sidebarContent}
      </Drawer>

      {/* ── Основная область ── */}
      <div className="main-area" style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>

        <Header style={{
          background: '#fff',
          padding: '0 16px',
          height: 56,
          lineHeight: '56px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
          position: 'sticky',
          top: 0,
          zIndex: 100,
        }}>
          {/* Гамбургер — только мобилка */}
          <Button
            className="hamburger"
            type="text"
            icon={<MenuOutlined style={{ fontSize: 20 }} />}
            onClick={() => setDrawerOpen(true)}
            style={{ marginRight: 8, padding: 4 }}
          />

          <Typography.Text strong style={{ fontSize: 16, flex: 1, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
            🐑 Арашан
          </Typography.Text>

          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
            <Avatar icon={<UserOutlined />} size={28} style={{ background: '#764ba2' }} />
            <Typography.Text className="username-text" style={{ fontSize: 13, maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {user?.name || user?.username}
            </Typography.Text>
            <Button
              icon={<LogoutOutlined />}
              onClick={logout}
              size="small"
              type="text"
              danger
            >
              <span className="logout-label">Выйти</span>
            </Button>
          </div>
        </Header>

        <div style={{ padding: '12px 12px', flex: 1, minWidth: 0, boxSizing: 'border-box' }}>
          <Outlet />
        </div>
      </div>

      <style>{`
        /* Десктоп: отодвигаем контент на ширину сайдбара */
        @media (min-width: 768px) {
          .main-area { margin-left: ${SIDEBAR_W}px; }
          .hamburger { display: none !important; }
          .desktop-sidebar { display: block !important; }
        }
        /* Мобилка: сайдбар скрыт, контент на всю ширину */
        @media (max-width: 767px) {
          .main-area { margin-left: 0 !important; }
          .desktop-sidebar { display: none !important; }
          .username-text { display: none !important; }
          .logout-label { display: none; }
        }
      `}</style>
    </div>
  );
}
